import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsLeft: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.92.16v15.68L4.08 8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsLeft
